<template>
  <section class="text-center">
    <section class="row">
      <div class="col">
        <div class="row d-flex flex-wrap">
          <div
            class="mx-auto mb-3 col-6 col-md-6 col-lg fs-7 d-flex justify-content-center"
            v-for="(type, index) in types"
            :key="index"
          >
            <article
              class="rounded shadow w-100 p-3 pb-5 position-relative warehouse-volume-card"
              :class="{ 'primary-bg-color text-white': cardSelected(type.volume), 'warehouse-volume-info-card': type.showInfo }"
            >
              <div v-if="type.showInfo" class="primary-bg-color text-white p-2 pt-1 position-relative rounded">
                <p class="position-absolute end-0 pe-1">
                  <span class="p-1 material-icons fs-6 text-white cursor-pointer d-inline-block fw-bold" @click="type.showInfo = false;">close</span>
                </p>

                <p class="pt-1 mb-0 mb-sm-1 font-gotham-m fs-6 title">
                  Volumen de {{ type.m3 }}m<sup>3</sup>
                </p>

                <p class="m-0 description">
                  ¿Qué cabe en este espacio?
                </p>

                <img v-if="type.image === 0" class="my-2" src="~images/bodegas/Iconos/warehouse_by_volume/img-size6m.png" alt="" height="58">
                <img v-else-if="type.image === 1" class="my-2" src="~images/bodegas/Iconos/warehouse_by_volume/img-size12m.png" alt="" height="58">
                <img v-else-if="type.image === 2" class="my-2" src="~images/bodegas/Iconos/warehouse_by_volume/img-size24m.png" alt="" height="58">


                <p class="info-text" v-html="type.info"></p>
              </div>

              <template v-else>
                <p class="mb-0 mb-sm-1 font-gotham-m fs-6 title">
                  Volumen de {{ type.m3 }}m<sup>3</sup>
                </p>
                <p class="m-0 description">
                  Equivale a <span class="d-none d-sm-inline">bodega de</span> {{ type.m2 }}m<sup>2</sup>
                </p>

                <img v-if="type.image === 0" class="warehouse-volume mb-3 mt-2 my-md-3 w-auto" src="~images/bodegas/Iconos/warehouse_by_volume/Img-6m2.png" alt="" height="100">
                <img v-else-if="type.image === 1" class="warehouse-volume mb-3 mt-2 my-md-3 w-auto" src="~images/bodegas/Iconos/warehouse_by_volume/Img-12m2.png" alt="" height="100">
                <img v-else-if="type.image === 2" class="warehouse-volume mb-3 mt-2 my-md-3 w-auto" src="~images/bodegas/Iconos/warehouse_by_volume/Img-24m2.png" alt="" height="100">

                <div class="position-absolute bottom-0 end-0 w-100 px-3 pb-3">
                  <button
                    class="mt-3 btn btn-secondary px-1 border-0 font-gotham-m w-100"
                    :class="{ 'bg-white primary-text-color': cardSelected(type.volume), 'primary-bg-color': !cardSelected(type.volume) }"
                    @click="selectVolume(type.volume)"
                  >
                    {{ cardSelected(type.volume) ? 'SELECCIONADO' : 'SELECCIONAR' }}
                  </button>

                  <p class="d-none d-md-inline-block m-0 mt-2 pt-1 footer cursor-pointer" @click="type.showInfo = true;">
                    <span class="position-relative d-inline-block">
                      <span
                        class="material-icons fs-7 position-absolute start-0"
                        :class="{ 'text-white': cardSelected(type.volume), 'primary-text-color': !cardSelected(type.volume) }"
                      >info</span>
                    </span>

                    ¿Qué cabe aquí?
                  </p>
                </div>
              </template>
            </article>
          </div>

          <div class="mx-auto mb-3 col-6 col-md-6 col-lg fs-7 d-flex justify-content-center">
            <article
              class="rounded shadow w-100 p-3 pb-5 position-relative warehouse-volume-card"
              :class="{ 'primary-bg-color text-white': cardSelected(0) }"
            >
              <p class="pt-2 pt-md-0 mt-3 mb-5 mb-md-0 fs-4 custom-title">
                🤔 <br>
                Necesito ayuda <br>
                para estimar <br>
                los m<sup>3</sup>
              </p>

              <div class="position-absolute bottom-0 end-0 w-100 px-3 pb-3">
                <button
                  class="mt-3 btn btn-secondary px-1 border-0 font-gotham-m w-100"
                  :class="{ 'bg-white primary-text-color': cardSelected(0), 'primary-bg-color': !cardSelected(0) }"
                  @click="selectVolume(0)"
                >
                  {{ cardSelected(0) ? 'SELECCIONADO' : 'SELECCIONAR' }}
                </button>

                <p class="d-none d-md-block m-0 mt-2 pt-1 footer">
                  Estima tus m<sup>3</sup> en 1 paso
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="row mt-2">
      <div class="col col-md-6 col-lg-4 mx-auto">
        <div class="dropdown">
          <button class="form-control position-relative" data-bs-toggle="dropdown" aria-expanded="false">
            <span v-if="[null, 0].includes(volumeSelected) || !volumeSelectedIsCustom">
              VER OTROS TAMAÑOS
            </span>

            <span v-else>
              Volumen {{ volumeSelected }}m<sup>3</sup>
            </span>

            <span class="material-icons position-absolute top-50 end-0 translate-middle-y">expand_more</span>
          </button>
          <ul class="dropdown-menu w-100 text-center overflow-auto" style="height: 200px;">
            <li v-for="indexCustomVolume in 40" :key="'custom-volume-' + indexCustomVolume">
              <a href="javascript:void(0);" @click="selectVolume(indexCustomVolume, true)" class="w-100 d-inline-block py-1 fs-7 text-black text-decoration-none">
                Volumen {{ indexCustomVolume }}m<sup>3</sup>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import segmentTrack from '../../../../common/mixins/segmentTrack'

export default {
  mixins: [segmentTrack],

  data () {
    return {
      volumeSelectedIsCustom: false,
      types: [
        {
          name: 'Volumen de 3m<sup>3</sup>',
          m3: '3',
          m2: '2,2',
          info: 'Ideal para cosas personales, por ejemplo: 5 a 7 cajas, bicicleta, tabla de surf, un colchón, una mesa lateral o velador, una cómoda o closet mediano.',
          image: 0,
          volume: 3,
          showInfo: false
        },
        {
          name: 'Volumen de 6m<sup>3</sup>',
          m3: '6',
          m2: '4,3',
          info: 'Ideal para una habitación mediana, por ejemplo: 10 cajas de distintos tamaños, 1 cama king, 3 sillas, rack para TV, TV, sillón.<br><br>',
          image: 1,
          volume: 6,
          showInfo: false
        },
        {
          name: 'Volumen de 9m<sup>3</sup>',
          m3: '9',
          m2: '8,7',
          info: 'Ideal para un departamento, por ejemplo: 15 cajas de distintos tamaños, 1 cama king, 3 sillas, rack TV, TV, sillones, refrigerador, comedor, etc.',
          image: 2,
          volume: 9,
          showInfo: false
        }
      ]
    }
  },

  mounted() {
    this.sendSegmentTrack('MEXICAN_WAREHOUSE_BOT_SEGMENT_PUBLIC', 'Mexican Warehouse Rental Bot', 'Choose Volume Step')
  },

  computed: {
    volumeSelected: {
      get () {
        return this.$store.state.warehouseRental.volume;
      },

      set (value) {
        this.$store.commit('setWarehouseRental', {
          volume: value
        });
      }
    },

    cardSelected () {
      return (volume) => (!this.volumeSelectedIsCustom && this.volumeSelected === volume);
    }
  },

  methods: {
    selectVolume (volume, isCustom = false) {
      this.volumeSelected = volume;
      this.volumeSelectedIsCustom = isCustom;
    }
  }
}
</script>

<style scoped>
.warehouse-volume-card .footer {
  font-size: .70rem;
}

.warehouse-volume-card .footer .material-icons {
  margin-left: -14px;
  bottom: -2px;
  font-size: .70rem;
}

.warehouse-volume-card {
  padding-bottom: 45px !important;
}

@media (max-width: 575px) {
  .warehouse-volume-card .title,
  .warehouse-volume-card button {
    font-size: .85rem !important;
  }

  .warehouse-volume-card .description {
    font-size: .65rem !important;
  }

  .warehouse-volume-card img.warehouse-volume {
    height: 55px;
  }

  .warehouse-volume-card .custom-title {
    font-size: 1rem !important;
    margin: 0 !important;
  }
}

@media (max-width: 320px) {
  .warehouse-volume-card .title,
  .warehouse-volume-card button {
    font-size: .75rem !important;
  }
  .warehouse-volume-card img.warehouse-volume {
    height: 70px;
  }

  .warehouse-volume-card .custom-title {
    font-size: .85rem !important;
  }
}

@media (min-width: 768px) {
  .warehouse-volume-card {
    padding-bottom: 80px !important;
  }
}

.warehouse-volume-info-card {
  padding: 16px !important;
}

.warehouse-volume-info-card .info-text {
  font-size: .75rem !important;
}
</style>
